import { StreemApiDeviceSupportedVideoCodecs } from '@streem/api';
export function determineSupportedVideoCodecs() {
    return [StreemApiDeviceSupportedVideoCodecs.VP8, StreemApiDeviceSupportedVideoCodecs.VP9];
}
//# sourceMappingURL=determine_supported_video_codecs.js.map